const serviceErrorHandler = (err) => {
  console.log(err);
  const data = err?.response?.data;
  if (data) {
    if (data?.details?.length > 0) {
      return data.details[0].message;
    } else if (data?.message) {
      return data.message;
    }
  }
  return "Something went wrong. Try again later.";
};
export { serviceErrorHandler };
